import React, { useEffect, useState } from "react";
import { Button, Table, Modal, Form, Message, Segment } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import { useTranslation } from "react-i18next";
import ConfirmComponent from "../../app/common/form/ConfirmComponent";

export default observer(function EmailTemplatesPage() {
  const { emailTemplateStore, modalStore } = useStore();
  const [open, setOpen] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState<any>(null);
  const { t } = useTranslation();

  useEffect(() => {
    emailTemplateStore.fetchTemplates();
  }, [emailTemplateStore]);

  const handleEdit = (template: any) => {
    setEditingTemplate(template);
    setOpen(true);
  };

  const handleSave = async () => {
    if (editingTemplate.id) {
      await emailTemplateStore.updateTemplate(editingTemplate);
    } else {
      await emailTemplateStore.createTemplate(editingTemplate);
    }
    setOpen(false);
    setEditingTemplate(null);
  };

  const handleDelete = (id: string) => {
    modalStore.openModal(
      <ConfirmComponent
        text={t("general.areYouSure")}
        onYes={async () => {
          await emailTemplateStore.deleteTemplate(id);
          modalStore.closeModal();
        }}
        onCancel={modalStore.closeModal}
      />
    );
  };

  const handleAdd = () => {
    setEditingTemplate({ subject: "", body: "" });
    setOpen(true);
  };

  return (
    <>
      <Button onClick={handleAdd}>
        {t("emails.templates.add")}
      </Button>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{t("emails.templates.subject")}</Table.HeaderCell>
            <Table.HeaderCell>{t("emails.templates.actions")}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {emailTemplateStore.templates.map((tpl) => (
            <Table.Row key={tpl.id}>
              <Table.Cell>{tpl.subject}</Table.Cell>
              <Table.Cell>
                <Button onClick={() => handleEdit(tpl)}>{t("emails.templates.edit")}</Button>
                <Button
                  color="red"
                  onClick={() => handleDelete(tpl.id)}
                >
                  {t("emails.templates.delete")}
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Modal.Header>{t("emails.templates.edit")}</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Input
              label={t("emails.templates.subject")}
              value={editingTemplate?.subject || ""}
              onChange={e => setEditingTemplate({ ...editingTemplate, subject: e.target.value })}
            />
            <Form.TextArea
              label={t("emails.templates.body")}
              value={editingTemplate?.body || ""}
              onChange={e => setEditingTemplate({ ...editingTemplate, body: e.target.value })}
            />
          </Form>
          <Message info>
            <Message.Header>{t("emails.templates.variablesTitle")}</Message.Header>
            <p>{t("emails.templates.variablesDescription")}</p>
            <Message.List>
              <Message.Item>{t("emails.templates.variableMemberNumber")}</Message.Item>
              <Message.Item>{t("emails.templates.variableFirstName")}</Message.Item>
              <Message.Item>{t("emails.templates.variableLastName")}</Message.Item>
            </Message.List>
          </Message>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={handleSave} positive>{t("emails.templates.save")}</Button>
          <Button onClick={() => setOpen(false)}>{t("emails.templates.cancel")}</Button>
        </Modal.Actions>

      </Modal>

    </>
  );
});
